import PropTypes from 'prop-types'
import { AbacProvider } from 'react-abac'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAC } from '../../../redux/selectors/AC'
import AuthExperienceSelectors from '../../../redux/selectors/experiences/Auth'

const AccessControlProvider = ({ children, loadingPlaceholder }) => {
  const { rulesPopulated, rules, permissionKeys } = useSelector(selectAC)
  const profile = useSelector(AuthExperienceSelectors.profile)
  const isAuthenticated = useSelector(AuthExperienceSelectors.isAuthenticated)

  const authUser = useMemo(
    () => ({
      id: profile?.id,
      roles: profile?.roleId ? [profile.roleId] : [],
      permissions: permissionKeys
    }),
    [profile?.id, profile?.roleId, permissionKeys]
  )

  if (isAuthenticated && !rulesPopulated) {
    return loadingPlaceholder || null
  }

  return (
    <AbacProvider
      user={authUser}
      roles={authUser.roles}
      rules={rules}
      permissions={authUser.permissions}
    >
      {children}
    </AbacProvider>
  )
}

AccessControlProvider.propTypes = {
  children: PropTypes.node,
  loadingPlaceholder: PropTypes.node
}

export default AccessControlProvider
